import axios from "@/plugins/axios";

// Export-header lookup. The backend returns the latest survey-cycle year (taken
// from tapispusingan: MAX(tahun) of the pusingan-01 rows — a cycle's year is the
// year of its opening round) plus the admin-editable Jata Negara title lines.
// Fetched once per page load and cached — every export page shares the same
// in-flight/settled promise, so the header costs at most one HTTP call no matter
// how many exports run.
// Single source for the export title on every Jadual Awalan / Kemudahan Asas
// page — change it here and all PDF and Excel headers follow.
const BASE_TITLE = "SURVEI PENDAPATAN, PERBELANJAAN PENGGUNAAN ISI RUMAH DAN KEMUDAHAN ASAS";
// Fallback for the lines under the Jata Negara crest when the lookup fails —
// mirrors APP_LOGO_TITLE_DEFAULT in the backend's analisis_config/config.js.
const DEFAULT_JATA_TITLE = ["KEMENTERIAN EKONOMI", "JABATAN PERANGKAAN MALAYSIA"];

let headerPromise = null;

// The raw payload — year, jataTitleLines, theme. Exported so services/theme.js
// shares this one cached call instead of adding a second round-trip.
export function exportMeta() {
  return fetchHeader();
}

// Drop the cached payload so the next read re-fetches. Called after an admin
// saves a config row: without it the cache lives as long as the SPA does, and a
// repainted theme or edited logo title would need a browser reload to show.
export function clearExportMeta() {
  headerPromise = null;
}

function fetchHeader() {
  if (!headerPromise) {
    headerPromise = axios
      .get(`${process.env.VUE_APP_API_URL}/JadualAwalan/getSurveyYear`)
      .then(res => (res.data && res.data.data) || {})
      .catch(() => {
        headerPromise = null; // failed lookup isn't cached — next export retries
        return {};
      });
  }
  return headerPromise;
}

export async function getSurveyYear() {
  return (await fetchHeader()).year || "";
}

// "SURVEI … KEMUDAHAN ASAS 2024" — falls back to the bare title when
// the year can't be fetched, so exports never block on this lookup failing.
export async function surveyTitle() {
  const year = await getSurveyYear();
  return year ? `${BASE_TITLE} ${year}` : BASE_TITLE;
}

// Lines printed under the Jata Negara crest in export headers. Editable at
// /config (analisis_config: type 'app', name 'logo_jata_negara_title').
export async function jataTitleLines() {
  const lines = (await fetchHeader()).jataTitleLines;
  return Array.isArray(lines) && lines.length ? lines : DEFAULT_JATA_TITLE;
}
